import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/authentication.service';
import { ApiService } from '../../shared/api.service';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-org-management',
  templateUrl: './org-management.component.html',
  styleUrls: ['./org-management.component.css']
})
export class OrgManagementComponent implements OnInit, OnDestroy {
  userSubscription: Subscription;
  idToken: string;
  userRole: string;
  orgList: Array<any>;
  orgListDisplayed: Array<any>;
  loading = true;
  isEditing = false;
  showActiveOnly = false;

  searchTerm$ = new Subject<string>();
  searchTermSubscription: Subscription;

  constructor(private angularFireAuth: AngularFireAuth, private authenticationService: AuthenticationService, private router: Router, private apiService: ApiService) {
    this.searchTermSubscription = this.searchTerm$.pipe(
      debounceTime(100))
      .subscribe(term => {
        this.searchOrgs(term);
      });
  }

  ngOnInit(): void {
    this.userSubscription = this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        const userData = this.authenticationService.userData;
        this.userRole = this.authenticationService.userRole;
        const token = await user.getIdTokenResult();
        this.idToken = token.token;
        await this.getOrgList();
        this.loading = false;

        if (this.userRole !== 'superuser' || !this.idToken) {
          await this.router.navigate(['/']);
        }
      } else {
        await this.router.navigate(['/']);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.searchTermSubscription) {
      this.searchTermSubscription.unsubscribe();
    }
  }

  private async getOrgList() {
    this.orgList = await this.apiService.getAllOrgs(this.idToken);
    for (const org of this.orgList) {
      const orgUsers = await this.apiService.getOrgUsers(this.idToken, org.id);
      org.numberOfUsers = orgUsers.length;
      org.users = orgUsers;
    }
    this.orgListDisplayed = this.orgList;
  }

  onSort($event: MouseEvent) {

  }

  editTestTypes(id: string) {

  }

  async editOrgActivation(org) {
    const active = !org.active;
    org.active = active;
    const data = {
      active
    };
    await this.apiService.updateOrgData(this.idToken, org.id, data);
  }

  private searchOrgs(term) {

    const filterValue = term;
    this.orgListDisplayed = this.orgList;
    // this.filterDisplayedItems();
    // console.log(this.itemsToDisplayFiltered, filterValue);
    this.orgListDisplayed = this.orgListDisplayed.filter(org => {
      return (
        org.name?.toLowerCase().includes(filterValue.toLowerCase()) ||
        org.id?.toString().includes(filterValue.toLowerCase())
      );
    });


  }

  updateSearchTerm($event) {
    this.searchTerm$.next($event.target.value);
  }

  filterActive() {
    this.showActiveOnly = !this.showActiveOnly;
  }

  async navigateToOrg(org: any) {
    await this.router.navigate(['/organization/', org.id], {state: org});
  }
}
